import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../../modules/shared/animation';

import PersonalDataForm from './components/forms/personal-data';
import ChangePasswordForm from './components/forms/change-password';
import TwoFactorAuthenticationForm from './components/forms/two-factor-authentication';
import NotificationsForm from './components/forms/notification';
import Balances from './components/forms/balance';
import Payments from './components/forms/payment';

lessRequire('modules/profile/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = renderViewsState(props => {
	const { intl } = props;
	const connectedBalances = props.balances && props.balances.connected || [];
	const can_edit_password = !_get(props, 'data.profile.feature_flags.cant_edit_password');

	return (
		<Animate>
			<div className="profile-wrap container">
				<div className="content-container content-container-tabs font-proxima-nova-regular">
					<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'personal')}>
						<span>{intl('Личные данные')}</span><span className="after"/>
					</a>
					<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'password')}>
						<span>{intl('Смена пароля')}<div className="border" /></span><span className="after"/>
					</a>
					{/*<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'two-facto-authentication')}>*/}
					{/*<span>{intl('Безопасность')}<div className="border" /></span><span className="after"/>*/}
					{/*</a>*/}
					<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'notifications')}>
						<span>{intl('Настройки оповещений')}<div className="border" /></span><span className="after"/>
					</a>
					{!isRocket && connectedBalances.length > 1 && (
						<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'currencies')}>
							<span>{intl('Валюты баланса')}<div className="border" /></span><span className="after"/>
						</a>
					)}
					<a href='#' className="anchorBtn" onClick={e => scrollToElement(e, 'payments')}>
						<span>{intl('Платежные данные')}<div className="border" /></span><span className="after"/>
					</a>
				</div>

				<div className="content-container">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Личные данные')}</h2>
					</div>

					<div className="content-container__form">
						<PersonalDataForm
							{...props}
							initialValues={props.personalDataForm.initialValues}
							uploadError={props.personalDataForm.uploadError}
							enableReinitialize={true}
						/>
					</div>
				</div>

				{
					can_edit_password &&
					<div className="content-container" id="password">
						<div className="content-container__title">
							<h2 className="font-proxima-nova-bold">{intl('Смена пароля')}</h2>
						</div>
						<div className="content-container__form">
							<ChangePasswordForm
								{...props}
								initialValues={props.passwordDataForm.initialValues}
							/>
						</div>
					</div>
				}

				<div className="content-container" id="two-facto-authentication">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Двухфакторная аутентификация')}</h2>
					</div>
					<div className="content-container__form font-proxima-nova-regular">
						<TwoFactorAuthenticationForm
							{...props}
							initialValues={props.twoFactorAuthenticationForm.initialValues}
						/>
					</div>
				</div>

				<div className="content-container" id="notifications">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Настройки оповещений')}</h2>
					</div>
					<div className="content-container__form">
						<NotificationsForm
							{...props}
							initialValues={props.notificationsDataFrom.initialValues}
						/>
					</div>
				</div>
				{!isRocket && (
					<div className="content-container" id="currencies">
						<div className="content-container__title">
							<h2 className="font-proxima-nova-bold">{intl('Валюты баланса')}</h2>
						</div>
						<div className="content-container__form">
							<Balances
								{...props}
								data={props.balances}
							/>
						</div>
					</div>
				)}

				<div className="content-container" id="payments">
					<div className="content-container__title">
						<h2 className="font-proxima-nova-bold">{intl('Платежные данные')}</h2>
					</div>
					<div className="content-container__form">
						<Payments
							{...props}
							data={props.paymentsData}
							initialValues={props.paymentsData.initialValues}
							enableReinitialize={true}
							keepDirtyOnReinitialize={true}
						/>
					</div>
				</div>

			</div>
		</Animate>
	);
});

const scrollToElement = (e, elementId) => {
	e.preventDefault();
	window.scrollTo(0, document.getElementById(elementId).offsetTop);
};

export default connect(
	state => ({
		data: selectors.getData(state),
		personalDataForm: selectors.getPersonalDataForm(state),
		languages: selectors.getLanguages(state),
		timezones: selectors.getTimezones(state),
		balances: selectors.getBalances(state),
		notificationTypes:  selectors.getNotifiTypes(state),
		passwordDataForm: selectors.getPasswordFormData(state),
		twoFactorAuthenticationForm: selectors.getTwoFactorAuthenticationFormData(state),
		notificationsDataFrom: selectors.getNotificationsDataForm(state),
		payoutCredentialFields: selectors.getPayoutCredentialFields(state),
		paymentsData: selectors.getPaymentsData(state),
		progressBar: selectors.getProgressBar(state),
		showModalTimezone: selectors.getShowModalTimezone(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/main.js